module.exports = __webpack_public_path__ + "img/verticalBg.b61440d3.png";